import { TextFormatter } from "../components/tools/TextFormatter";

export function TextFormatterPage() {
  return <TextFormatter />;
}
